import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of Arizona",
  shortName: "AZ Blue",
  slug: "az-blue-insurance",
  seoTitle:
    "Blue Cross Blue Shield of Arizona TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of Arizona policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "AZ Blue TMS coverage, Blue Cross Blue Shield Arizona SPRAVATO authorization, AZ Blue mental health benefits Coral Springs FL, BCBS Arizona depression treatment Florida",
};

export const AzBlueInsurance = () => <InsurancePageTemplate config={config} />;
export default AzBlueInsurance;
